export default __webpack_public_path__ + "static/media/textDemandMb1.bbd8ecb6.png";